export const DATA_HOOKS = {
  BREADCRUMB: 'breadcrumb',
  BREADCRUMB_BUTTON: 'breadcrumbButton',
};
